export default "__VITE_ASSET__Bt4mIC3Y__"